import { render, staticRenderFns } from "./DetailedLists.vue?vue&type=template&id=279e8d02&scoped=true&"
import script from "./DetailedLists.vue?vue&type=script&lang=js&"
export * from "./DetailedLists.vue?vue&type=script&lang=js&"
import style0 from "./DetailedLists.vue?vue&type=style&index=0&id=279e8d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e8d02",
  null
  
)

export default component.exports